import { useGrowthBook } from '@growthbook/growthbook-react'

import { useAppSelector } from 'src/Hooks/redux'
import {
  getIsNewUserForThresholdCouponExperiment,
  getUserId,
} from 'src/Redux/auth-process/userSlice/selectors'

export const THRESHOLD_COUPON_GB_FEATURE = 'threshold-based-coupon'

// `isEligible` keeps users who would never see the coupon block in either
// variation out of the exposure count.
export const useIsThresholdCouponTestVariant = (
  isEligible: boolean,
): boolean => {
  const growthbook = useGrowthBook()
  const userId = useAppSelector(getUserId)
  const isRegisteredAfterCutoff = useAppSelector(
    getIsNewUserForThresholdCouponExperiment,
  )

  const isAttributesSynced =
    Boolean(userId) && growthbook.getAttributes()?.id === userId

  if (
    !isEligible ||
    !isRegisteredAfterCutoff ||
    !growthbook.ready ||
    !isAttributesSynced
  ) {
    return false
  }

  return growthbook.getFeatureValue(THRESHOLD_COUPON_GB_FEATURE, false)
}
